import { render, staticRenderFns } from "./CartaoDeNotaFiscalEmitida.vue?vue&type=template&id=31ea3dd1&scoped=true"
import script from "./CartaoDeNotaFiscalEmitida.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeNotaFiscalEmitida.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeNotaFiscalEmitida.vue?vue&type=style&index=0&id=31ea3dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea3dd1",
  null
  
)

export default component.exports